import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './styles.css';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showNovaSenha, setShowNovaSenha] = useState(false);
  const [showConfirmarSenha, setShowConfirmarSenha] = useState(false);

  useEffect(() => {
    document.body.classList.add('forgot-password-page');
    return () => {
      document.body.classList.remove('forgot-password-page');
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    const trimmedToken = String(token || '').trim();
    if (!trimmedToken) {
      setError('Token inválido. Use o link enviado por e-mail.');
      return;
    }
    if (!novaSenha || !confirmarSenha) {
      setError('Preencha a nova senha e a confirmação.');
      return;
    }
    if (novaSenha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres.');
      return;
    }
    if (novaSenha !== confirmarSenha) {
      setError('As senhas precisam ser iguais.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/usuarios/resetar-senha', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json'
        },
        body: JSON.stringify({ token: trimmedToken, novaSenha, confirmarSenha })
      });
      const text = await res.text();
      if (!res.ok) {
        let msg = 'Não foi possível redefinir a senha.';
        try {
          const data = text ? JSON.parse(text) : null;
          msg = data?.message || data?.erro || msg;
        } catch (_) {}
        throw new Error(msg);
      }
      setMessage('Senha redefinida com sucesso. Você já pode fazer login.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err?.message || 'Erro ao redefinir senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <section className="forgot-password-section">
        <div className="forgot-password-container">
          <div className="forgot-password-content">
            <div className="forgot-password-left">
              <div className="forgot-password-form-container">
                <h1>Redefinir senha</h1>
                <p className="description">Digite a nova senha para a sua conta.</p>

                <form className="forgot-password-form" onSubmit={handleSubmit}>
                  <div className="form-group password-field">
                    <input
                      type={showNovaSenha ? 'text' : 'password'}
                      placeholder="Nova senha"
                      className="form-input"
                      value={novaSenha}
                      onChange={(e) => setNovaSenha(e.target.value)}
                      minLength="6"
                      required
                    />
                    <button
                      type="button"
                      className="toggle-password"
                      onClick={() => setShowNovaSenha((prev) => !prev)}
                      aria-label={showNovaSenha ? 'Ocultar senha' : 'Mostrar senha'}
                      title={showNovaSenha ? 'Ocultar senha' : 'Mostrar senha'}
                    >
                      {showNovaSenha ? '🙈' : '👁️'}
                    </button>
                  </div>
                  <div className="form-group password-field">
                    <input
                      type={showConfirmarSenha ? 'text' : 'password'}
                      placeholder="Confirmar nova senha"
                      className="form-input"
                      value={confirmarSenha}
                      onChange={(e) => setConfirmarSenha(e.target.value)}
                      minLength="6"
                      required
                    />
                    <button
                      type="button"
                      className="toggle-password"
                      onClick={() => setShowConfirmarSenha((prev) => !prev)}
                      aria-label={showConfirmarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                      title={showConfirmarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                    >
                      {showConfirmarSenha ? '🙈' : '👁️'}
                    </button>
                  </div>

                  <button type="submit" className="submit-button" disabled={loading}>
                    {loading ? 'Salvando...' : 'Redefinir senha'}
                  </button>
                </form>

                {message && <p className="success-message" style={{ marginTop: 12 }}>{message}</p>}
                {error && <p className="error-message" style={{ marginTop: 12 }}>{error}</p>}

                <div className="forgot-password-footer">
                  <p>
                    Lembrou-se da senha? <Link to="/login">Voltar para o login</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ResetPassword;
